<template>
  <div class="main-content">
    <div class="card"></div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading.global" :color="$constants.LOADING_COLOR" class="text-center"/>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      loading: {
        global: false,
      }
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async getRecords(page = 1) {
      this.loading.global = true;
      const {data} = await api.index('/new/users/managers/shifts?page=' + page);
    }
  }
}

</script>
